import React from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';
//import classNames from 'classnames';

const stringOrNode = PropTypes.oneOfType([
	PropTypes.string,
	PropTypes.node
]);

// TODO i18n
const defaultProps = {
	addLabelText: 'Добавить "{label}"?',
	backspaceToRemoveMessage: 'Нажмите Backspace чтобы удалить {last label}',
	clearAllText: 'Очистить все',
	clearValueText: 'Очистить',
	noResultsText: 'Ничего не найдено',
	placeholder: 'Выбрать…',
	searchPromptText: 'Введите текст, чтобы найти варианты',
	loadingPlaceholder: 'Загрузка…',
	searchingText: 'Поиск…'
};

export class SelectAsync extends React.PureComponent {
	static defaultProps = defaultProps;

	focus() {
		this._select && this._select.focus && this._select.focus();
	}

	render() {
		const className = 'is-clearable';

		return <ReactSelect.Async {...this.props} className={className} ref={(sel) => {
			this._select = sel
		}}/>
	}
}

SelectAsync.propTypes = {
	cache: PropTypes.any,                     // object to use to cache results, can be null to disable cache
	ignoreAccents: PropTypes.bool,            // whether to strip diacritics when filtering (shared with Select)
	ignoreCase: PropTypes.bool,               // whether to perform case-insensitive filtering (shared with Select)
	isLoading: PropTypes.bool,                // overrides the isLoading state when set to true
	loadOptions: PropTypes.func.isRequired,   // function to call to load options asynchronously
	loadingPlaceholder: PropTypes.string,     // replaces the placeholder while options are loading
	minimumInput: PropTypes.number,           // the minimum number of characters that trigger loadOptions
	noResultsText: stringOrNode,                    // placeholder displayed when there are no matching search results (shared with Select)
	onInputChange: PropTypes.func,            // onInputChange handler: function (inputValue) {}
	placeholder: stringOrNode,                      // field placeholder, displayed when there's no value (shared with Select)
	searchPromptText: stringOrNode,       // label to prompt for search input
	searchingText: PropTypes.string,          // message to display while options are loading
};

export class SelectCreatable extends React.PureComponent {
	static defaultProps = Object.assign({}, defaultProps, {
		placeholder: 'Введите или выберите значение…',
		promptTextCreator: (label) => `Добавить "${label}"`
	});

	handleOnFocus(event) {
		if (this.props && this.props.value) {
			this._select.setState({inputValue: this.props.value});
			event.preventDefault();
		}
	}

	focus() {
		this._select && this._select.focus && this._select.focus();
	}

	render() {
		const className = 'is-clearable';

		return <ReactSelect.Creatable {...this.props} className={className} ref={(sel) => {
			this._select = (sel && sel.select) || null
		}} onFocus={this.handleOnFocus.bind(this)}/>
	}
}

SelectCreatable.propTypes = {
// See Select.propTypes.filterOptions
	filterOptions: PropTypes.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: PropTypes.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: PropTypes.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: PropTypes.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: PropTypes.func,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: PropTypes.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: PropTypes.func
};

class Select extends React.PureComponent {
	static defaultProps = defaultProps;

	static Async = SelectAsync;
	static Creatable = SelectCreatable;

	focus() {
		this._select && this._select.focus && this._select.focus();
	}

	render() {
		const className = 'is-clearable';

		return <ReactSelect {...this.props} className={className} ref={(sel) => {
			this._select = sel
		}}/>
	}
}

Select.propTypes = {
	addLabelText: PropTypes.string,       // placeholder displayed when you want to add a label on a multi-value input
	'aria-label': PropTypes.string,       // Aria label (for assistive tech)
	'aria-labelledby': PropTypes.string,	// HTML ID of an element that should be used as the label (for assistive tech)
	autoBlur: PropTypes.bool,             // automatically blur the component when an option is selected
	autofocus: PropTypes.bool,            // autofocus the component on mount
	autosize: PropTypes.bool,             // whether to enable autosizing or not
	backspaceRemoves: PropTypes.bool,     // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: PropTypes.string,  // Message to use for screenreaders to press backspace to remove the current item -
	// {label} is replaced with the item label
	className: PropTypes.string,          // className for the outer element
	clearAllText: stringOrNode,                 // title for the "clear" control when multi: true
	clearValueText: stringOrNode,               // title for the "clear" control
	clearable: PropTypes.bool,            // should it be possible to reset value
	delimiter: PropTypes.string,          // delimiter to use to join multiple values for the hidden field value
	disabled: PropTypes.bool,             // whether the Select is disabled or not
	escapeClearsValue: PropTypes.bool,    // whether escape clears the value when the menu is closed
	filterOption: PropTypes.func,         // method to filter a single option (option, filterString)
	filterOptions: PropTypes.any,         // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	ignoreAccents: PropTypes.bool,        // whether to strip diacritics when filtering
	ignoreCase: PropTypes.bool,           // whether to perform case-insensitive filtering
	inputProps: PropTypes.object,         // custom attributes for the Input
	inputRenderer: PropTypes.func,        // returns a custom input component
	instanceId: PropTypes.string,         // set the components instanceId
	isLoading: PropTypes.bool,            // whether the Select is loading externally or not (such as options being loaded)
	joinValues: PropTypes.bool,           // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: PropTypes.string,           // path of the label value in option objects
	matchPos: PropTypes.string,           // (any|start) match the start or entire string when filtering
	matchProp: PropTypes.string,          // (any|label|value) which option property to filter on
	menuBuffer: PropTypes.number,         // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: PropTypes.object, // optional style to apply to the menu container
	menuRenderer: PropTypes.func,         // renders a custom menu with options
	menuStyle: PropTypes.object,          // optional style to apply to the menu
	multi: PropTypes.bool,                // multi-value input
	name: PropTypes.string,               // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode,                // placeholder displayed when there are no matching search results
	onBlur: PropTypes.func,               // onBlur handler: function (event) {}
	onBlurResetsInput: PropTypes.bool,    // whether input is cleared on blur
	onChange: PropTypes.func,             // onChange handler: function (newValue) {}
	onClose: PropTypes.func,              // fires when the menu is closed
	onCloseResetsInput: PropTypes.bool,		// whether input is cleared when menu is closed through the arrow
	onFocus: PropTypes.func,              // onFocus handler: function (event) {}
	onInputChange: PropTypes.func,        // onInputChange handler: function (inputValue) {}
	onInputKeyDown: PropTypes.func,       // input keyDown handler: function (event) {}
	onMenuScrollToBottom: PropTypes.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: PropTypes.func,               // fires when the menu is opened
	onValueClick: PropTypes.func,         // onClick handler for value labels: function (value, event) {}
	openAfterFocus: PropTypes.bool,       // boolean to enable opening dropdown when focused
	openOnFocus: PropTypes.bool,          // always open options menu on focus
	optionClassName: PropTypes.string,    // additional class(es) to apply to the <Option /> elements
	optionComponent: PropTypes.func,      // option component to render in dropdown
	optionRenderer: PropTypes.func,       // optionRenderer: function (option) {}
	options: PropTypes.array,             // array of options
	pageSize: PropTypes.number,           // number of entries to page when using page up/down keys
	placeholder: stringOrNode,                  // field placeholder, displayed when there's no value
	required: PropTypes.bool,             // applies HTML5 required attribute when needed
	resetValue: PropTypes.any,            // value to use when you clear the control
	scrollMenuIntoView: PropTypes.bool,   // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: PropTypes.bool,           // whether to enable searching feature or not
	simpleValue: PropTypes.bool,          // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: PropTypes.object,              // optional style to apply to the control
	tabIndex: PropTypes.string,           // optional tab index of the control
	tabSelectsValue: PropTypes.bool,      // whether to treat tabbing out while focused to be value selection
	value: PropTypes.any,                 // initial field value
	valueComponent: PropTypes.func,       // value component to render
	valueKey: PropTypes.string,           // path of the label value in option objects
	valueRenderer: PropTypes.func,        // valueRenderer: function (option) {}
	wrapperStyle: PropTypes.object,       // optional style to apply to the component wrapper
};

export default Select;


// WEBPACK FOOTER //
// ./src/components/ui/Select.js